import {Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Header from './components/Header';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { Navigate } from 'react-router-dom';
import Logout from './components/Logout';
import Meistarklases from './pages/Meistarklases';
import Coupons from './pages/Coupons';
import FreeShipping from './pages/FreeShipping';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from './features/auth/authSlice';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

function TokenExpirationHandler() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    const checkTokenExpiration = () => {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user && user.token) {
        const decoded = jwtDecode(user.token)
        const currentTime = Date.now() / 1000 // Current time in seconds

        if (decoded.exp < currentTime) {
          dispatch(logout())
          navigate('/login')
        }
      }
    }

    // Check token expiration every 5 seconds
    const interval = setInterval(checkTokenExpiration, 5000)

    return () => clearInterval(interval)
  }, [dispatch, navigate])

  return null
}

function App() {
  return (
    <>
      <Router>
      <TokenExpirationHandler />
        <div className='container'>
        <Header />  
          <Routes>
            <Route path='/' element={<Dashboard />} />
            <Route path='/free-shipping' element={<FreeShipping />} />
            <Route path='/meistarklases' element={<Meistarklases />} />
            <Route path='/coupons' element={<Coupons />} />
            <Route path='/login' element={<Login />} />
            <Route path='/logout' element={<Logout />} />
            <Route path='*' element={<Navigate to="/" />} />
          </Routes>
        </div>
      
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
